<script>
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
      'Buy': 'Comprar',
      'The product has been added to your cart.': 'O produto foi adicionado em seu carrinho.',
      'Unable to add the product to your cart, please try again.': 'Não foi possível adicionar o produto em seu carrinho, tente novamente.',
    },
    es: {
      'Buy': 'Comprar',
      'The product has been added to your cart.': 'El producto se agregó a tu carrito.',
      'Unable to add the product to your cart, please try again.': 'No fue posible agregar el producto a tu carrito, inténtalo de nuevo.',
    }
  },
  props: {
    id: {
      default: ""
    },
    variations: {
      default: ""
    },
  },
  components: {},
  data() {
    return {
      loading: false,
      variation: Object.keys(this.variations).shift(),
      selected: true,
    };
  },
  methods: {
    buyProduct(variation) {
      if (variation) {
        this.loading = true

        api
          .post('store/cart', {
            id: this.variation,
            qty: 1,
            plus: 'yes'
          })
          .then(response => {
            if (response.data.status == 'success') {
              this.$toast.success(this.t('The product has been added to your cart.'))

              localStorage.removeItem('cart');
              this.$parent.getCart()
            } else {
              this.$toast.error(this.t('Unable to add the product to your cart, please try again.'))
            }

            this.loading = false
          })
          .catch(error => {
            if (error) {
              this.$toast.error(this.t('Unable to add the product to your cart, please try again.'))
            }
          })
      }
    }
  }
};
</script>

<template>
  <b-form @submit.prevent="buyProduct(id)">
    <select v-if="Object.keys(this.variations).length > 1" v-model="variation" class="custom-select mb-2">
      <option v-for="option in variations" :key="option.id" :value="option.id" :selected="[variation == null ? variation = option.id : false]">{{ option.name }}</option>
    </select>
    <b-button class="btn-block" type="submit" variant="default" :disabled="loading">
      {{ t('Buy') }}
      <b-spinner v-if="loading" small class="ml-2 align-middle" variant="secondary" role="status"></b-spinner>
    </b-button>
  </b-form>
</template>